/**
 * withErrorPage HOC
 */
import React from 'react';
import ErrorPage from '../../pages/_error';

/**
 * Redirect to ErrorPage if status code is 4xx or 5xx
 * @param WrappedComponent
 * @returns {Wrapper}
 */
const withErrorPage = WrappedComponent => {
  const Wrapper = props => {
    if (props && props?.statusCode && /^[5|4]\d{2}/.test(props?.statusCode)) {
      return <ErrorPage statusCode={props?.statusCode} />;
    }

    return <WrappedComponent {...props} />;
  };

  Wrapper.getInitialProps = async ctx => {
    // noinspection UnnecessaryLocalVariableJS
    const componentProps = WrappedComponent.getInitialProps && (await WrappedComponent.getInitialProps(ctx));

    return componentProps;
  };

  return Wrapper;
};

export default withErrorPage;
